<template>
    <div class="container">
        <breadcrumb :to="breadcrumbTo">{{ caseTitle }}</breadcrumb>
        <h1>Find mobilen frem</h1>

        <transition mode="out-in" name="fade">
            <div class="transition-root" key="startingCase" v-if="starting">
                <div class="row">
                    <loading-indicator>Starter spil..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="notLoading" v-if="!loading && !starting">
                <p>
                    Åben <strong>www.osonline.dk</strong> og vælg disse<br/>
                    emojis for at være med.
                </p>
                <emoji-code type="large"/>
                <div class="counter-container">
                    <counter :current="studentCount" class="counter">er med nu</counter>
                </div>
                <div class="continue-button-container">
                    <app-button v-on:onClick="onClickStart">Start</app-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import GamePhase from '@/enum/GamePhase'
    import GameClientEvent from '@/enum/GameClientEvent'
    import Breadcrumb from '@/components/breadcrumb'
    import LoadingIndicator from '@/components/loading-indicator'
    import EmojiCode from '@/components/emoji-code'
    import Counter from '@/components/counter'
    import * as MutationTypes from '@/store/mutation-types'
    import AppButton from '@/components/app-button/index'
    import {mapGetters} from 'vuex'
    import {$eBus} from '@/event-bus'
    import AppConfig from '@/app-config'
    import {getTeacherUrl} from '@/utils/UrlUtil'

    export default {
        components: {
            AppButton,
            EmojiCode,
            Breadcrumb,
            LoadingIndicator,
            Counter
        },
        data() {
            return {
                loading: true,
                starting: false,
                roomId: null,

                studentCount: 0
            }
        },
        mounted() {
            if (!this.currentCase || !this.$gameClient.isPhase([GamePhase.Lobby, GamePhase.Pages])) {
                console.log('Current case missing or $gameClient is not in the Lobby phase - going back to index')

                // The game is not at the right point right now.. let's revert the user to the connect screen
                this.$router.push(getTeacherUrl('select-case'))

                return
            }

            this.$gameClient.send({
                _phase: GamePhase.Lobby,
                _currentPageIndex: -1
            })

            this.roomId = this.$gameClient.roomId

            let themeId = this.$store.getters.getCurrentTheme.id
            let caseId = this.currentCase.id

            if (this.$gameClient.room) {
                this.onRoomStateChange(this.$gameClient.room, this.$gameClient.room.state);
            }

            $eBus.$on(GameClientEvent.RoomStateChange, this.onRoomStateChange);

            this.$apiClient.getCase(themeId, caseId, (_case) => {
                this.$store.commit(MutationTypes.SET_CURRENT_CASE, _case)

                this.loading = false

                if (AppConfig.autoLobbyStart) {
                    this.onClickStart()
                }
            })
        },
        beforeDestroy() {
            $eBus.$off(GameClientEvent.RoomStateChange, this.onRoomStateChange);
        },
        computed: {
            ...mapGetters({
                currentCase: 'getCurrentCase',
            }),
            breadcrumbTo() {
                return getTeacherUrl('select-case');
            },
            caseTitle() {
                return this.currentCase ? this.currentCase.title : ''
            },
        },
        methods: {
            onRoomStateChange(room, state) {
                if (state.hasOwnProperty('studentCount')) {
                    this.studentCount = parseInt(state.studentCount, 10);
                }
            },
            onClickStart() {
                if (this.starting) {
                    return
                }

                this.starting = true

                console.log('Changing game phase to GamePhase.Pages')

                this.$gameClient.send({
                    _phase: GamePhase.Pages,
                    _currentPageIndex: 0
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/variables.less";

    .select-theme-container {
        margin-top: @breadcrumb-offset;
    }

    .counter {
        margin: 30px auto 50px auto;
    }

    .continue-button-container {
        text-align: center;
    }
</style>